




// ReceivedDocumentsTable.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Pagination,
  Tooltip,
  Typography,
  CircularProgress,
  Button
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ExportDropdown from "../../../../components/ExportDropdown.js";
import CustomText, { textStyles } from "../../../../components/CustomText.js";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";// ✅ needed since token is stored encrypted
import { showUnderDevelopment } from "../../../../components/alerts.js";
import TruncatedCell from "../../../../components/TruncatedCell.js";
// 👉 your assets (adjust paths/names if needed)
import document1 from "../../../../assets/document1.svg"; // pdf icon
import document2 from "../../../../assets/document2.svg"; // image/doc icon
import empty from "../../../../assets/empty.png";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from '@mui/icons-material/Upload';
import StatusDropdown from "../../../../components/StatusDropdown.js";
import ExportCompanyDocumentsExcel from "./Excel.js";
import ExportCompanyDocumentsPDF from "./DocumentPdf.js";
import { pdf } from "@react-pdf/renderer";
import DownloadIcon from "@mui/icons-material/Download";
import ViewDrawer from "./DetailsDrawer.js";
import FilterDrawer from "./FilterDrawer.js";
import {useCompanyLogo} from "../../../../components/FetchLogoPdf";
import {useLocation,useNavigate} from "react-router-dom";
import back from "../../../../assets/back.svg";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";
// ---- shared styles
const headerStyle = {
  color: "#44546F",
  fontSize: "15px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const dataStyle = {
  color: "#172B4D",
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

// ---- helpers
const formatDateTime = (iso) => {
  if (!iso) return "-";
  const localDateTime = convertUTCToLocalDateTime(iso, {
    locale: "en-GB",
    format: "DD MMM YYYY",
  });
  return localDateTime === "—" ? "-" : localDateTime;
};

const fileTypeIcon = (fileType) => {
  const ft = (fileType || "").toLowerCase();
  if (ft.includes("pdf")) return document1;
  return document2;
};

export default function CompanyDocuments() {
  const { t } = useTranslation();

  // ---- state
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  // pagination (from backend)
  const [page, setPage] = useState(1);
  const [limit] = useState(5); // adjust as needed
  const [totalPages, setTotalPages] = useState(1);

const company = useSelector((state) => state.auth.company);
const companyId = company?.id;
const [loading, setLoading] = useState(true);      // first full load
const [tableLoading, setTableLoading] = useState(false); 
// console.log("Redux coany object:", company);
// console.log("Company ID:", companyId);mp
const [addDrawerOpen, setAddDrawerOpen] = useState(false);
const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
const [downloadingId, setDownloadingId] = useState(null);

const [viewDrawerOpen, setViewDrawerOpen] = useState(false);
const [viewRow, setViewRow] = useState(null);
const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;

// Filter state
const [filters, setFilters] = useState({ category: "", startDate: "", endDate: "", status: "" });
const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
const [isFilterApplied, setIsFilterApplied] = useState(false);
const fetchDocs = async () => {
  if (!token) return;

  if (rows.length === 0) setLoading(true);
  else setTableLoading(true);

  try {
    const queryParams = new URLSearchParams({
      limit: limit.toString(),
      page: page.toString(),
    });

    if (search) queryParams.append("search", search);
    if (filters.category) queryParams.append("category", filters.category);
    if (filters.startDate) queryParams.append("date_from", filters.startDate);
    if (filters.endDate) queryParams.append("date_to", filters.endDate);
    if (filters.status) queryParams.append("status", filters.status);

    console.log("🔎 Filters applied:", filters);
    console.log("🌐 API URL:", `${BASE_URL}/documents/company?${queryParams.toString()}`);

    const res = await fetch(
      `${BASE_URL}/documents/company?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) throw new Error("Failed to fetch documents");

    const data = await res.json();
    console.log("🔎 API Response:", data);
    
    const mapped = (data?.data?.documents || []).map((doc) => ({
      id: doc.id,
      name: doc.name,
      description: doc.description,
      subject: doc.subject,
      fileType: doc.file_type,
      category: doc.category,
      status: doc.status,
      documentUrl: doc.document_url,
      createdAt: doc.created_at,
      updatedAt: doc.updated_at,
      hasAccess: doc.has_access,
    }));

    console.log("📦 Documents received after filter:", mapped);

    setRows(mapped);
    // Update pagination to match API response structure
    const pagination = data?.data?.pagination;
    setTotalPages(pagination?.total_pages || pagination?.pages || 1);
  } catch (err) {
    console.error("❌ Error fetching documents:", err);
  } finally {
    setLoading(false);
    setTableLoading(false);
  }
};

// run on mount / pagination / search / filters
useEffect(() => {
  fetchDocs();
}, [ token,page, limit,search, filters]);


  // ---- selection
  const allSelected = rows.length > 0 && rows.every((r) => selected.includes(r.id));
  const toggleAll = () => {
    if (allSelected) {
      setSelected((prev) => prev.filter((id) => !rows.some((r) => r.id === id)));
    } else {
      setSelected((prev) => Array.from(new Set([...prev, ...rows.map((r) => r.id)])));
    }
  };
  const toggleOne = (id) =>
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  // ---- row menu
  const openMenu = (e, row) => {
    setAnchorEl(e.currentTarget);
    setSelectedRow(row);
  };
  const closeMenu = () => setAnchorEl(null);
const { logo } = useCompanyLogo(token);

  const fetchAllCompanyDocuments = async (token, filters = {}) => {
  try {
   let url = `${BASE_URL}/documents/company?limit=1000&page=1`;

    if (filters.category) url += `&category=${filters.category}`;
    if (filters.startDate) url += `&date_from=${filters.startDate}`;
    if (filters.endDate) url += `&date_to=${filters.endDate}`;
    if (filters.status) url += `&status=${filters.status}`;

    const res = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const json = await res.json();

    if (json.error) {
      console.error("❌ Failed to fetch company documents:", json.message);
      return [];
    }

    return (json.data?.documents || []).map((doc) => ({
      id: doc.id,
      documentName: doc.name || "-",
      description: doc.description || "-",
      subject: doc.subject || "-",
      fileType: doc.file_type || "-",
      status: doc.status || "-",
      date: formatDateTime(doc.created_at),
    }));
  } catch (err) {
    console.error("❌ Error fetching all company documents:", err);
    return [];
  }
};

  return (
    <>

                     {fromDashboard && (
      <Box
        sx={{
          border: '1px solid #E4E6EF',
          borderRadius: 2,
          px: 2,
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: 55,
          mb: 2,
          ml:1, mr:1
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
          onClick={() => navigate(-1)}
        >
          <img src={back} style={{ width: 30, height: 30 }} />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: '14px',
              color: '#626F86',
              textAlign: 'center'
            }}
          >
            {t('worker')} 
          </CustomText>
        </Box>
      </Box>
    )}
    
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        border: "2px solid #091E4224",
        py: 2,
        px: 0,
        ml: 1,
        mr: 1,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 2,
          px: 2,
          borderBottom: "2px solid #091E4224",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CustomText
          sx={{
            ...textStyles.h1,
            fontWeight: 600,
            fontSize: "18px",
            color: "#003149",
            textAlign: "left",
          }}
        >
          {t("documents.companyDocuments") || "Company Documents"}
        </CustomText>
          {tableLoading && (
    <CircularProgress size={20} sx={{ color: "#006EC2" }} />
  )}
</Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
          <Box
            sx={{
              px: 1,
              py: 0.2,
              borderRadius: 1,
              height: 34,
              border: "2px solid #091E4224",
              display: "flex",
              alignItems: "center",
              minWidth: 250,
              maxWidth: 320,
            }}
          >
            <InputBase
              placeholder={t("documents.searchPlaceholder") || "Search document..."}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{
                fontSize: 14,
                fontFamily: "Poppins, sans-serif",
                color: "#939393",
                width: "100%",
              }}
            />
            <SearchIcon sx={{ fontSize: 20, color: "#888", ml: 1 }} />
          </Box>

          {/* Filter Button */}
          {isFilterApplied ? (
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 34,
                height: 34,
                borderRadius: 1,
                bgcolor: "#1976d2", // blue when applied
              }}
            >
              {/* Filter Icon (white) */}
              <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

              {/* Cross Icon to clear filters */}
              <IconButton
                size="small"
                onClick={() => {
                  const cleared = { category: "", startDate: "", endDate: "", status: "" };
                  setFilters(cleared);
                  setPage(1);
                  setIsFilterApplied(false);
                }}
                sx={{
                  position: "absolute",
                  top: -6,
                  right: -6,
                  bgcolor: "white",
                  width: 18,
                  height: 18,
                  border: "1px solid #C4C4C4",
                  "&:hover": { bgcolor: "#f5f5f5" },
                }}
              >
                <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
              </IconButton>
            </Box>
          ) : (
            <IconButton
              onClick={() => setFilterDrawerOpen(true)}
              sx={{
                border: "1px solid #C4C4C4",
                borderRadius: 1,
                width: 34,
                height: 34,
              }}
            >
              <FilterAltIcon />
            </IconButton>
          )}

<ExportDropdown
  onDownloadPDF={async () => {
    const allData = await fetchAllCompanyDocuments(token, filters);
    const blobStream = pdf(<ExportCompanyDocumentsPDF data={allData}  logo={logo} />).toBlob();
    blobStream.then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Company_Documents_Report_${new Date().toISOString().slice(0, 10)}.pdf`;
      link.click();
    });
  }}
  onDownloadExcel={async () => {
    const allData = await fetchAllCompanyDocuments(token, filters);
    ExportCompanyDocumentsExcel(allData);
  }}
/>

                 
        </Box>
      </Box>

      {/* Table */}

      {loading ? (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 10 }}>
    <CircularProgress size={40} sx={{ color: "#006EC2" }} />
  </Box>
) : rows.length === 0 ? (
  // Empty state
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      py: 5,
    }}
  >
    <img src={empty} alt="No Data" style={{ width: 200, marginBottom: 16 }} />
    <Typography sx={{ fontSize: "15px",        fontFamily: 'Poppins, sans-serif',
 }}>
  {t("documents.received.empty")}
    </Typography>
  </Box>
) : (
  // Table + Pagination + Menu
  <>
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <Table>
          <TableHead>
            <TableRow>
             
              <TableCell sx={headerStyle}>{t("documents.th.id") || "ID"}</TableCell>
              <TableCell sx={headerStyle}>
                {t("documents.th.documentName") || "Document Name"}
              </TableCell>
              <TableCell sx={headerStyle}>
                {t("documents.th.description") || "Description"}
              </TableCell>
              <TableCell sx={headerStyle}>
                {t("documents.th.subject") || "Subject"}
              </TableCell>
              <TableCell sx={headerStyle}>
                {t("documents.th.fileType") || "File Type"}
              </TableCell>
              <TableCell sx={headerStyle}>
                {t("documents.th.status") || "Status"}
              </TableCell>
              <TableCell sx={headerStyle}>
                {t("documents.th.uploadedAt") || "Uploaded At"}
              </TableCell>
              <TableCell sx={headerStyle}>{t("common.action") || "Action"}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
               

                <TableCell sx={dataStyle}>{row.id}</TableCell>
                <TableCell sx={dataStyle}>
                  <TruncatedCell text={row.name} />
                </TableCell>
                <TableCell sx={dataStyle}>
                  <TruncatedCell text={row.description || "-"} />
                </TableCell>
                <TableCell sx={dataStyle}>
                  <TruncatedCell text={row.subject || "-"} />
                </TableCell>
                <TableCell sx={dataStyle}>
                  {row.fileType?.toLowerCase().includes("pdf") ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Tooltip >
                        <Box
                          component="img"
                          src={document1}
                          alt="pdf"
                          sx={{ width: 22, height: 22 }}
                        />
                      </Tooltip>
                      <Tooltip >
                        <IconButton
                          size="small"
                          onClick={async () => {
                            if (!row.documentUrl) return;
                            try {
                              setDownloadingId(row.id);
                              // Construct full URL if document_url is just an identifier
                              const downloadUrl = row.documentUrl.startsWith('http') 
                                ? row.documentUrl 
                                : `${BASE_URL}/documents/${row.id}/download`;
                              const res = await fetch(downloadUrl, {
                                headers: {
                                  Authorization: `Bearer ${token}`,
                                },
                              });
                              if (!res.ok) throw new Error("Failed to download file");
                              const blob = await res.blob();

                              const link = document.createElement("a");
                              link.href = URL.createObjectURL(blob);
                              link.download = (row.name || "document") + ".pdf";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } catch (err) {
                              console.error("❌ Download failed:", err);
                            } finally {
                              setDownloadingId(null);
                            }
                          }}
                        >
                          {downloadingId === row.id ? (
                            <CircularProgress size={20} sx={{ color: "#006EC2" }} />
                          ) : (
                            <DownloadIcon sx={{ fontSize: 20, color: "#006EC2" }} />
                          )}
                        </IconButton>
                      </Tooltip>
                    </Box>
                  ) : (
                    <Tooltip title={(row.fileType || "").toUpperCase()}>
                      <Box
                        component="img"
                        src={fileTypeIcon(row.fileType)}
                        alt={row.fileType || "file"}
                        sx={{ width: 22, height: 22 }}
                      />
                    </Tooltip>
                  )}
                </TableCell>
                <TableCell sx={dataStyle}>
                  {row.status ? (
                    <Box sx={{ pointerEvents: "none", display: "flex", justifyContent: "flex-start" }}>
                      <StatusDropdown currentStatus={row.status} />
                    </Box>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell sx={dataStyle}>
                  {row.createdAt ? formatDateTime(row.createdAt) : "-"}
                </TableCell>

                <TableCell>
                  <IconButton size="small" onClick={(e) => openMenu(e, row)}>
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {/* Pagination (backend) */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            mt: 2,
          }}
        >
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, v) => setPage(v)}
            shape="rounded"
            color="primary"
            size="small"
            sx={{
              "& .MuiPaginationItem-root": {
                fontFamily: "Poppins, sans-serif",
                fontSize: 13,
                fontWeight: 500,
              },
              "& .Mui-selected": {
                backgroundColor: "#E9F3FF",
                color: "#006EC2",
              },
            }}
          />
        </Box>

        {/* Row menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeMenu}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          {/* <MenuItem
            onClick={showUnderDevelopment}
            sx={{ fontSize: 14, fontFamily: "Poppins, sans-serif" }}
          >
            {t("common.view") || "View"}
          </MenuItem> */}
          <MenuItem
  onClick={() => {
    setViewRow(selectedRow);
    setViewDrawerOpen(true);
    closeMenu();
  }}
  sx={{ fontSize: 14, fontFamily: "Poppins, sans-serif" }}
>
  {t("common.view") || "View"}
</MenuItem>
        </Menu>
      </Box>
      </>
      )}
      
    </Box>
    <FilterDrawer
      open={filterDrawerOpen}
      onClose={() => setFilterDrawerOpen(false)}
      filters={filters}
      setFilters={setFilters}
      onApplyFilters={(newFilters) => {
        setFilters(newFilters);
        setPage(1); // reset to page 1
        // ✅ check if any filter is active
        const applied = newFilters.category || newFilters.startDate || newFilters.endDate || newFilters.status;
        setIsFilterApplied(!!applied);
      }}
    />
    <ViewDrawer
      open={viewDrawerOpen}
      onClose={() => setViewDrawerOpen(false)}
      row={viewRow}
    />
    </>
  );
}